import { render, staticRenderFns } from "./AuthResetPassword.vue?vue&type=template&id=b7f0affc&"
import script from "./AuthResetPassword.vue?vue&type=script&lang=js&"
export * from "./AuthResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports